(() => {
  const COOKIE_NAME = 'golden_strip_age_verified';
  const VERIFIED_VALUE = '1';
  const root = document.documentElement;

  const hasVerificationCookie = () =>
    document.cookie
      .split(';')
      .map((cookie) => cookie.trim())
      .some((cookie) => cookie === `${COOKIE_NAME}=${VERIFIED_VALUE}`);

  const setBackgroundInert = (gate, inert) => {
    for (const element of document.body.children) {
      if (!(element instanceof HTMLElement) || element === gate) continue;
      element.inert = inert;
    }
  };

  const initialize = () => {
    const gate = document.querySelector('[data-age-verification]');
    if (!(gate instanceof HTMLElement)) return;

    if (hasVerificationCookie()) {
      root.classList.remove('age-verification-pending');
      root.classList.add('age-verification-confirmed');
      gate.remove();
      return;
    }

    root.classList.add('age-verification-pending');
    root.classList.remove('age-verification-confirmed');
    setBackgroundInert(gate, true);

    const confirmButton = gate.querySelector('[data-age-confirm]');
    const exitButton = gate.querySelector('[data-age-exit]');
    const errorMessage = gate.querySelector('[data-age-error]');
    const focusable = [confirmButton, exitButton].filter((element) => element instanceof HTMLElement);

    window.requestAnimationFrame(() => confirmButton?.focus({ preventScroll: true }));

    gate.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (event.key !== 'Tab' || focusable.length === 0) return;

      event.preventDefault();
      const currentIndex = focusable.indexOf(document.activeElement);
      const direction = event.shiftKey ? -1 : 1;
      const nextIndex = currentIndex < 0
        ? 0
        : (currentIndex + direction + focusable.length) % focusable.length;
      focusable[nextIndex].focus();
    });

    confirmButton?.addEventListener('click', () => {
      document.cookie = `${COOKIE_NAME}=${VERIFIED_VALUE}; Path=/; SameSite=Lax; Secure`;

      if (!hasVerificationCookie()) {
        if (errorMessage instanceof HTMLElement) errorMessage.hidden = false;
        return;
      }

      gate.classList.add('is-closing');
      root.classList.remove('age-verification-pending');
      root.classList.add('age-verification-confirmed');
      setBackgroundInert(gate, false);

      window.setTimeout(() => gate.remove(), 180);
    });

    exitButton?.addEventListener('click', () => {
      const exitUrl = gate.dataset.exitUrl || 'https://www.google.com/';
      window.location.replace(exitUrl);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
